<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 black--text">
            <base-breadcrumbs class="pa-0" :items="breadcrumbs" />
            <div class="body-1 font-weight-bold">
              Hasil Pelaksanaan {{ jenis === 'bcmp' ? 'Bimtek' : 'Diklat Luring Tersistem' }} |<span
                class="font-weight-regular"
              >
                {{ $getDeepObj(detail, 'nama') }}
              </span>
            </div>
            Silakan unduh sertifikat peserta dengan menekan tombol UNDUH SERTIFIKAT. Sertifikat dapat diunduh bagi
            peserta yang nilainnya sesuai dengan ketentuan penerbitan
            <div class="mt-2">
              <v-icon left>mdi-clock</v-icon>
              {{
                $durasi(
                  $getDeepObj(detail, 'paud_diklat_luring.data.tgl_mulai') ||
                    $getDeepObj(detail, 'paud_diklat_bcmp.data.tgl_mulai'),
                  $getDeepObj(detail, 'paud_diklat_luring.data.tgl_selesai') ||
                    $getDeepObj(detail, 'paud_diklat_bcmp.data.tgl_selesai')
                )
              }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header @search="onSearch" :btnFilter="false" @reload="onReload" @filter="onFilter">
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> Peserta Diklat
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="primary">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Nama Peserta</div>
                          <strong class="mt-1">
                            {{
                              $getDeepObj(item, 'paud_peserta_nonptk.data.nama') ||
                              $getDeepObj(item, 'ptk.data.nama') ||
                              $getDeepObj(item, 'akun.data.nama')
                            }}
                            <v-icon
                              v-if="['Kurang'].includes(item.predikat) && jenis !== 'bcmp'"
                              right
                              size="20"
                              color="orange"
                              style="cursor: pointer"
                              @click="onDetail"
                            >
                              mdi-alert-circle
                            </v-icon>
                          </strong>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Surel</div>
                          <span class="mt-1">
                            {{
                              $getDeepObj(item, 'paud_peserta_nonptk.data.email') ||
                              $getDeepObj(item, 'ptk.data.email') ||
                              $getDeepObj(item, 'akun.data.email')
                            }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Hasil Nilai</div>
                          <span class="mt-1">
                            {{ $getDeepObj(item, 'predikat') }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">{{ jenis === 'bcmp' ? '' : 'Nilai Akhir' }}</div>
                          <span v-if="jenis === 'luring'" class="mt-1">
                            {{ ![undefined, null, ''].includes(item.nilai) ? item.nilai : '-' }}
                          </span>
                          <template v-else>
                            <div class="black--text">
                              <span class="label--text">Nilai PM</span> :
                              {{ $getDeepObj(item, 'n_pendalaman_materi') || '' }}
                            </div>
                            <div class="black--text">
                              <span class="label--text">Nilai TM</span> :
                              {{ $getDeepObj(item, 'n_tugas_mandiri') || '' }}
                            </div>
                            <div class="black--text"
                              ><span class="label--text">Nilai Akhir</span> :
                              {{ $getDeepObj(item, 'nilai') || '' }}</div
                            >
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label--text mt-3">Unduhan Sertifikat</div>
                      <v-btn
                        color="orange"
                        class="my-1"
                        depressed
                        :dark="['Sangat Baik', 'Amat Baik', 'Baik', 'Cukup'].includes(item.predikat)"
                        :disabled="!['Sangat Baik', 'Amat Baik', 'Baik', 'Cukup'].includes(item.predikat)"
                        @click="onDownloadSertifikat(item)"
                      >
                        <v-icon left>mdi-download</v-icon>
                        Unduh
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
import list from '@mixins/list';
export default {
  mixins: [list],
  components: { BaseBreadcrumbs },
  data() {
    return {
      formulir: {},
      mapels: [],
      detail: {},
      catatans: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    jenis() {
      return this.$getDeepObj(this.$route, 'meta.jenis') || 'luring';
    },

    breadcrumbs() {
      return [
        { text: `Diklat ${this.jenis === 'bcmp' ? 'BCMP' : 'Luring Terseistem'}`, to: `kelola-diklat-${this.jenis}` },
        { text: 'Sertifikat Diklat', to: `${this.jenis}-sertifikat` },
        {
          text: `${this.$getDeepObj(this, 'detail.nama') || ''}`,
        },
      ];
    },

    id() {
      return this.$route.params.kelas_id || 0;
    },
  },
  mounted() {
    Object.assign(this.attr, { id: this.id, jenis: this.jenis });
  },
  created() {
    this.getDetail({ jenis: this.jenis === 'luring' ? 'luring/' : 'bcmp/sertifikat/', id: this.id }).then(
      ({ data }) => {
        this.detail = data || {};
      }
    );
  },
  methods: {
    ...mapActions('diklatSertifikat', {
      fetch: 'getListKandidat',
      downloadSertifikat: 'downloadSertifikat',
    }),

    ...mapActions('diklatVerval', {
      getDetail: 'getDetail',
    }),

    onDownloadSertifikat(item) {
      this.downloadSertifikat({
        kelas_id: this.id,
        id: item.id,
        jenis: this.jenis,
        method: this.jenis === 'bcmp' ? 'post' : 'get',
      }).then(({ data }) => {
        const resp = (data && data.data) || {};
        if (this.$getAttr(data, 'url_download') || this.$getAttr(resp, 'url_download')) {
          window.open(this.$getAttr(data, 'url_download') || this.$getAttr(resp, 'url_download'), '_blank');
        } else {
          this.$error('Unduhan belum tersedia');
        }
      });
    },

    onDetail() {
      const mJenjang = {
        1: 'Dasar',
        2: 'Lanjut',
        3: 'Mahir',
      };

      const msg = [
        `<div class="black--text"> <h2>Tidak Mendapatkan Sertifikat</h2><br/>`,
        `Mohon maaf, Anda <b>Belum Lulus</b> dalam kelas Diklat Berjenjang Tingkat `,
        `${
          mJenjang[Number(this.$getDeepObj(this.detail, 'paud_diklat_luring.data.k_jenjang_diklat_paud'))]
        } PAUD. Silakan menghubungi LPD terkait untuk bisa mengikuti periode lainnya</div>`,
      ];
      this.$notifikasi(msg.join(''), 'Informasi Peserta', {
        icon: 'mdi-alert-circle',
        btnColor: 'secondary',
      });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
